import React, { ReactNode } from 'react';
import { OrderedLineAmount, OrderedLineRow, OrderedLineTitle, OrderedTotalRow } from './styles';

interface SummaryLineProps {
  title: string;
  price: string;
  /* VIS-2193. Drawn before the title: the product's thumbnail on an ordered line. */
  leading?: ReactNode;
  className?: string;
}

/*
 * VIS-2193. One row of the add-on money summary: what it is on the left, the amount on the right. Built
 * here rather than on RCL's `AddOnItem`, which takes a title and a price and nothing else, so an ordered
 * line could never carry its product image. Same props as the row it replaces, so callers did not move.
 */
export const AddOnsLine = ({ title, price, leading, className }: SummaryLineProps): JSX.Element => (
  <OrderedLineRow className={className}>
    {leading}
    <OrderedLineTitle>{title}</OrderedLineTitle>
    <OrderedLineAmount>{price}</OrderedLineAmount>
  </OrderedLineRow>
);

/* The total: the same row at 700, under a rule. */
export const TotalLine = ({ title, price, className }: Omit<SummaryLineProps, 'leading'>): JSX.Element => (
  <OrderedTotalRow className={className}>
    <OrderedLineTitle>{title}</OrderedLineTitle>
    <OrderedLineAmount>{price}</OrderedLineAmount>
  </OrderedTotalRow>
);
